<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'"
          >{{ aLang.c_create }} cấu hình đăng ký khám</span
        >
        <span v-if="mData.viewMode == 'update'"
          >{{ aLang.c_update }} cấu hình đăng ký khám</span
        >
        <span v-if="mData.viewMode == 'detail'"
          >{{ aLang.c_detail }} cấu hình đăng ký khám</span
        >
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <!-- <b-col md="4">
              <el-form-item label="Thứ tự" prop="index">
                <el-input
                  type="number"
                  v-model="mData.dataForm.index"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  :step="1"
                  :min="1"
                ></el-input>
              </el-form-item>
            </b-col> -->
            <b-col md="4">
              <el-form-item label="Mã ứng dụng" prop="app_code">
                <el-input
                  type="text"
                  v-model.trim="mData.dataForm.app_code"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên ứng dụng" prop="app_name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.app_name"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item label=" " prop="" class="mt-2">
                <el-checkbox
                  v-model="mData.dataForm.disabled"
                  :disabled="mData.viewMode == 'detail'"
                  >Khóa</el-checkbox
                >
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <el-form-item label="Chọn tỉnh" prop="province_code">
                <el-select
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.province_code"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  @change="fn_changeHospital()"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listProvince"
                    :key="item.PROVINCE_CODE"
                    :label="item.PROVINCE_NAME"
                    :value="item.PROVINCE_CODE"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4" >
              <el-form-item label="Cơ sở khám" prop="hospital_code">
                <el-select
                  :disabled="mData.viewMode == 'detail' || !mData.dataForm.province_code"
                  v-model="mData.dataForm.hospital_code"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  @change="$forceUpdate()"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listMedicalFacility"
                    :key="item.HOSPITAL_CODE"
                    :label="item.HOSPITAL_NAME"
                    :value="item.HOSPITAL_CODE"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <el-form-item label="Phí dịch vụ" prop="">
                <el-select
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.method_discount"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  @input="forceUpdateUI"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listMethodDiscount"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col
              md="4"
              v-if="mData.dataForm.method_discount == 'percentage_discount'"
            >
              <el-form-item label="Phí dịch vụ (%)" prop="percentage_discount">
                <el-input-number
                  type="number"
                  v-model="mData.dataForm.percentage_discount"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  :min="mData.dataDefault.limitPercentOptions.min"
                  :max="mData.dataDefault.limitPercentOptions.max"
                  :controls="mData.dataDefault.limitPercentOptions.controls"
                  prefix-icon="far fa-percent"
                  @input="forceUpdateUI"
                  @blur="
                    mData.dataForm.percentage_discount = fn_roundTo2Digit(
                      mData.dataForm.percentage_discount
                    )
                  "
                ></el-input-number>
              </el-form-item>
            </b-col>
            <b-col
              md="4"
              v-if="mData.dataForm.method_discount == 'money_discount'"
            >
              <el-form-item label="Phí dịch vụ (Số tiền)" prop="money_discount">
                <ElementUIMoney
                  v-model="mData.dataForm.money_discount"
                  label=""
                  :disabled="mData.viewMode == 'detail'"
                  :outlined="true"
                  :clearable="true"
                  :options="options"
                />
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
              >{{ aLang.c_create }}</el-button
            >

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
              >{{ aLang.c_update }}</el-button
            >

            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

    <script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import CauHinhDangKyKhamModel from "./CauHinhDangKyKhamModel";
import CauHinhDangKyKhamApi from "../../../moduleApi/CauHinhDangKyKhamApi";
import CoSoKhamBenhApi from "../../../moduleApi/CoSoKhamBenhApi";
import moment from "moment";
import ElementUIMoney from "../../../component/ElementUiMoney.vue";
import { fontAwesomePicker } from "font-awesome-picker";
import mushroom from "../../../service/mushroom.api.def";
import ValidService from "../../../service/ValidService";

export default {
  components: {
    "font-awesome-picker": fontAwesomePicker,
    ElementUIMoney,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 100,
        precision: 0,
      },
      mData: {
        viewMode: "create",
        moduleName: "CauHinhDangKyKham",
        dataDefault: {
          showSearchIcon: false,
          listAllMedical: [],
          listMedicalFacility: [],
          listProvince: [],
          listMethodDiscount: [
            {
              label: "Phí dịch vụ (%)",
              value: "percentage_discount",
            },
            {
              label: "Phí dịch vụ (Số tiền)",
              value: "money_discount",
            },
          ],
          limitPercentOptions: {
            min: 0,
            max: 100,
            controls: false,
          },
        },
        provice: {
          name: null,
          code: null,
        },
        dataForm: MethodService.copyObject(CauHinhDangKyKhamModel.dataForm),
        validForm: CauHinhDangKyKhamModel.validForm,
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (this.mData.dataForm.disabled) {
            this.mData.dataForm.disabled = "LOCK";
          } else {
            this.mData.dataForm.disabled = "UNLOCK";
          }
          if (this.mData.dataForm.app_name) {
            this.mData.dataForm.app_name = this.mData.dataForm.app_name.trim();
          }
          this.mData.dataForm.index = 1;
          console.log("this.mData.dataForm", this.mData.dataForm);
          if (type == "create") {
            try {
              await CauHinhDangKyKhamApi.create(this.mData.dataForm);
              await this.fn_resetForm();
            } catch (error) {
              window.toastr.error(error.detail);
            }
          }
          if (type == "update") {
            try {
              this.mData.dataForm.id = this.$router.currentRoute.params.id;
              if (
                this.mData.dataForm.method_discount == "percentage_discount"
              ) {
                this.mData.dataForm.money_discount = null;
              } else if (
                this.mData.dataForm.method_discount == "money_discount"
              ) {
                this.mData.dataForm.percentage_discount = null;
              } else {
                this.mData.dataForm.money_discount = null;
                this.mData.dataForm.percentage_discount = null;
              }
              await CauHinhDangKyKhamApi.update(this.mData.dataForm);
              await this.fn_go(-1);
            } catch (error) {
              window.toastr.error(error.detail);
            }
          }
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_changeHospital() {
      this.mData.dataDefault.listMedicalFacility = [];
      if (this.mData.dataForm.hospital_code) {
        this.mData.dataForm.hospital_code = null;
      }
      if (this.mData.dataDefault.listAllMedical.length == 0) {
        return;
      }
      try {
        let listMedicalFacility = this.mData.dataDefault.listAllMedical.filter(
          (elHospital) =>
            elHospital.PROVINCE_CODE == this.mData.dataForm.province_code
        );
        if (listMedicalFacility && listMedicalFacility.length > 0) {
          this.mData.dataDefault.listMedicalFacility = listMedicalFacility;
        }
        console.log("listMedicalFacility", listMedicalFacility);
      } catch (error) {
        console.log("error", error);
      }
    },
    async fn_getDataById(id) {
      let res = await CauHinhDangKyKhamApi.findById(id);
      if (res) {
        this.mData.dataForm = res.result;
        if (this.mData.dataForm.percentage_discount) {
          this.mData.dataForm.method_discount = "percentage_discount";
        } else if (this.mData.dataForm.money_discount) {
          this.mData.dataForm.method_discount = "money_discount";
        }
        if (this.mData.dataForm.disabled == "LOCK") {
          this.mData.dataForm.disabled = true;
        } else {
          this.mData.dataForm.disabled = false;
        }

        if (this.mData.dataForm.province_code) {
          let listMedicalFacility =
            this.mData.dataDefault.listAllMedical.filter(
              (elHospital) =>
                elHospital.PROVINCE_CODE == this.mData.dataForm.province_code
            );
          if (listMedicalFacility && listMedicalFacility.length > 0) {
            this.mData.dataDefault.listMedicalFacility = listMedicalFacility;
          }
        }
      }
    },
    async fn_initDataDefault() {
      // const coSoKhamBenhApiRes = await CoSoKhamBenhApi.list({sort: "created_time"});
      // if (coSoKhamBenhApiRes.result) {
      //   this.mData.dataDefault.listMedicalFacility = coSoKhamBenhApiRes.result;
      // }
      try {
        let body = {
          account: "tichhop",
          password: "tichhop",
        };
        let req = await fetch(`${mushroom.$using()}auth/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
        let res = await req.json();
        let resArrProvince;
        let resArrHospital;
        [resArrProvince, resArrHospital] = await Promise.all([
          CauHinhDangKyKhamApi.GetProvincal(),
          CauHinhDangKyKhamApi.getHospital(null, res.result.token),
        ]);
        if (
          resArrProvince &&
          resArrProvince.data &&
          resArrProvince.data.Data &&
          resArrProvince.data.Data.length > 0
        ) {
          this.mData.dataDefault.listProvince = resArrProvince.data.Data;
        }

        if (
          resArrHospital &&
          resArrHospital.data &&
          resArrHospital.data.Data &&
          resArrHospital.data.Data.length > 0
        ) {
          this.mData.dataDefault.listAllMedical = resArrHospital.data.Data;
        }
        console.log("listProvince", this.mData.dataDefault.listProvince);
        console.log("listAllMedical", this.mData.dataDefault.listAllMedical);
      } catch (error) {
        console.log("error", error);
      }
    },

    fn_roundTo2Digit(num) {
      return Math.round(num * 100) / 100;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
  },
  async created() {
    await this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted() {},
};
</script>
<style lang="css" scoped>
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style>
